import { Codesandbox } from "react-feather"
export default [
    {
        id: 'payment-information',
        title: 'Төлбөрийн мэдээлэл',
        icon: <i className="fal fa-money-check-alt"></i>,
        navLink: "student/payment-information"
    },
    {
        id: 'scholarship',
        title: 'Тэтгэлэг',
        icon: <Codesandbox size={8} />,
        navLink: "student/scholarship"
    },
]
